// extracted by mini-css-extract-plugin
export default {"btnsWrap":"_1yBVM-"};